module.exports = __webpack_public_path__ + "img/ctrl-a-stub-0.9cba16e9.svg";